import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], field: string, value: any = '', checkType: 'empty' | 'notEmpty' | 'equals' | 'ignore' = 'equals'): any[] {
        if (!items) {
            return [];
        }

        switch (checkType) {
            case 'ignore':
                return items;
            case 'empty':
                return items.filter(item => !this.getValue(item, field));
            case 'notEmpty':
                return items.filter(item => this.getValue(item, field));
            case 'equals':
            default:
                return items.filter(item => this.getValue(item, field) === value);
        }
    }

    getValue(item: any, field: string) {
        return field.split('.')
            .reduce((acc, value) => acc[value], item);
    }
}
